
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import { getSyncToken, isLogin } from '../api/util'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/AXlogin.vue'),
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../components/AXregister.vue'),
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: () => import('../views/ShoppingCart.vue'),
    meta:{
      requiresAuth: true  // 表示进入该路由需要登录
    }
  },
  {
    path: '/goodsOrder',
    name: 'goodsOrder',
    component: () => import('../views/GoodsOrder.vue'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('../components/AXpayment.vue'),
    meta:{
      requiresAuth: true
    }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('../views/PersonalCenter/index.vue'),
    meta:{
      requiresAuth: false
    },
    children: [
      {
        path: '/',
        name: '',
        component: () => import('../views/PersonalCenter/orderList.vue'),
        meta:{
          requiresAuth: false
        }
      },{
        path: '/user/returnOrExchange',
        name: 'returnOrExchange',
        component: () => import('../views/ReturnOrExchange/list.vue'),
        meta:{
          requiresAuth: false
        }
      }
    ]
  },
  {
    path: '/personalCenter',
    name: 'personalCenter',
    component: () => import('../views/PersonalCenter/personalCenter.vue'),
    meta:{
      requiresAuth: false
    },
    children: [
      {
        path: '/personalCenter/orderDetail',
        name: 'orderDetail',
        component: () => import('../views/PersonalCenter/orderDetail.vue'),
        meta:{
          requiresAuth: false
        }
      },{
        path: '/personalCenter/logistics',
        name: 'logistics',
        component: () => import('../views/PersonalCenter/logistics.vue'),
        meta:{
          requiresAuth: false
        }
      },{
        path: '/personalCenter/applyReturn',
        name: 'applyReturn',
        component: () => import('../views/PersonalCenter/applyReturn.vue'),
        meta:{
          requiresAuth: false
        }
      },{
        path: '/personalCenter/submitApplyReturn',
        name: 'applyReturn',
        component: () => import('../views/PersonalCenter/submitApplyReturn.vue'),
        meta:{
          requiresAuth: false
        }
      },
    ]
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('../views/Shop/index.vue'),
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/',
        name: '',
        component: () => import('../views/main.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/airCondition',
        name: 'airCondition',
        component: () => import('../views/Classification/AirCondition.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/goodsDetail',
        name: 'goodsDetail',
        component: () => import('../components/GoodsDetail.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/refrigerator',
        name: 'refrigerator',
        component: () => import('../views/Classification/Refrigerator.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/television',
        name: 'television',
        component: () => import('../views/Classification/Television.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/washingMachine',
        name: 'washingMachine',
        component: () => import('../views/Classification/WashingMachine.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/kitchenAppliances',
        name: 'kitchenAppliances',
        component: () => import('../views/Classification/KitchenAppliances.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/lifeAppliances',
        name: 'lifeAppliances',
        component: () => import('../views/Classification/LifeAppliances.vue'),
        meta:{
          requiresAuth: false
        }
      },
      {
        path: '/home/digitals',
        name: 'digitals',
        component: () => import('../views/Classification/Digitals.vue'),
        meta:{
          requiresAuth: false
        }
      },{
        path: '/home/industryReport',
        name: 'industryReport',
        component: () => import('../views/components/IndustryReport.vue'),
        meta:{
          requiresAuth: false
        }
      },
    ]
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order/index.vue'),
    meta:{
      requiresAuth: false
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if(to.meta.requiresAuth){
    let token = getSyncToken()
    // console.log(token,isLogin(),'11111111111111111111')
    if (token && isLogin()){
      next()
    } else{
      router.push({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

export default router
